<template>
    <div class="container">
        <template-component></template-component>
    </div>
</template>

<script>
    import TemplateComponent from '../components/TemplateComponent'

    export default {
        name: 'template',
        mixins: [],
        data() {
            return {}
        },
        computed: {},
        methods: {},
        watched: {},
        components: {
            TemplateComponent
        },
        created() {

        },
        mounted() {

        },
    }
</script>

<style lang="less" scoped>

</style>
